// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qu-0";